import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = { class: "col-xxl-8 order-2 order-xl-1" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_4 = { class: "card-body p-10" }
const _hoisted_5 = { class: "settings-tabs ps-0 mb-0 list-unstyled" }
const _hoisted_6 = {
  key: 0,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing settings-card"
}
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_8 = {
  key: 0,
  style: {"margin-top":"5%"}
}
const _hoisted_9 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_10 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_11 = {
  key: 1,
  style: {"margin-top":"5%"}
}
const _hoisted_12 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"green"}
}
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_16 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_19 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_22 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_23 = { class: "invalid-feedback" }
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_26 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_27 = { class: "invalid-feedback" }
const _hoisted_28 = { class: "col-md-6" }
const _hoisted_29 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_30 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_31 = { class: "invalid-feedback" }
const _hoisted_32 = { class: "col-md-6" }
const _hoisted_33 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_34 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_35 = { value: "ACTIVE" }
const _hoisted_36 = { value: "INACTIVE" }
const _hoisted_37 = { class: "invalid-feedback" }
const _hoisted_38 = { class: "col-md-12" }
const _hoisted_39 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_40 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_41 = { class: "invalid-feedback" }
const _hoisted_42 = { class: "col-md-6" }
const _hoisted_43 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_44 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_45 = { class: "invalid-feedback" }
const _hoisted_46 = { class: "col-md-6" }
const _hoisted_47 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_48 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_49 = { class: "invalid-feedback" }
const _hoisted_50 = { class: "col-md-6" }
const _hoisted_51 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_52 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_53 = { class: "invalid-feedback" }
const _hoisted_54 = { class: "col-md-6" }
const _hoisted_55 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_56 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_57 = { class: "col-md-6" }
const _hoisted_58 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_59 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_60 = { class: "col-md-12" }
const _hoisted_61 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_62 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_63 = { class: "col-md-6" }
const _hoisted_64 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_65 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_66 = { class: "col-md-6" }
const _hoisted_67 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_68 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_69 = { class: "col-md-6" }
const _hoisted_70 = { class: "form-group mb-15 mb-sm-20 mb-md-25 d-flex align-items-center" }
const _hoisted_71 = {
  for: "validatePayoutBeforProcess",
  class: "text-black fw-semibold mb-0"
}
const _hoisted_72 = { class: "col-md-6" }
const _hoisted_73 = { class: "form-group mb-15 mb-sm-20 mb-md-25 d-flex align-items-center" }
const _hoisted_74 = {
  for: "isTestOrganization",
  class: "text-black fw-semibold mb-0"
}
const _hoisted_75 = { class: "col-md-6" }
const _hoisted_76 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_77 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_78 = ["value"]
const _hoisted_79 = { class: "col-md-6" }
const _hoisted_80 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_81 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_82 = ["value"]
const _hoisted_83 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_84 = ["disabled"]
const _hoisted_85 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_86 = {
  key: 1,
  class: "text-center py-5"
}

import { ref, reactive, onMounted, inject, computed } from "vue";
import { useI18n } from "vue-i18n";
import * as yup from "yup";
import axios from "axios";
import router from '@/router';
import { checkSessionValidate } from "@/utils/function";

interface Organization {
  code: string;
  name: string;
  description: string | null;
  email: string;
  contact: string | null;
  status: string;
  bankDomiciliation: string | null;
  rib: string | null;
  cryptoAccount: string | null;
  validatePayoutBeforProcess: boolean;
  maxPayoutAmount: number | null;
  payoutValidationDelay: number | null;
  isTestOrganization: boolean;
  type: string | null;
  representativeName: string | null;
  representativeIdDocs: string | null;
  headOfficeAdress: string | null;
  createdAt: string | null;
  updatedAt: string | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'updateOrganization',
  setup(__props) {

const backApi = inject('back');
const { t } = useI18n();

const token: string | null = localStorage.getItem('login_token');
const codeUser: string | null = localStorage.getItem('code');
const role: string | null = localStorage.getItem('role');

// ⭐ Rôles autorisés à modifier l'organisation
const EDIT_ROLES = ['SUPERADMIN', 'BUSINESS', 'SUPPORT', 'ADMIN'];
const canEditOrganization = computed(() => !!role && EDIT_ROLES.includes(role));

const pageLoad = ref(false);
const btnLoad = ref(true);

const errors = ref('');
const errorId = ref('');
const success = ref('');

const errorsBis: Record<string, string> = {
  name: '',
  email: '',
  contact: '',
  status: '',
  description: '',
  bankDomiciliation: '',
  rib: '',
  cryptoAccount: '',
};

const formValues = reactive<Organization>({
  code: '',
  name: '',
  description: '',
  email: '',
  contact: '',
  status: 'ACTIVE',
  bankDomiciliation: '',
  rib: '',
  cryptoAccount: '',
  validatePayoutBeforProcess: false,
  maxPayoutAmount: null,
  payoutValidationDelay: null,
  isTestOrganization: false,
  type: '',
  representativeName: '',
  representativeIdDocs: '',
  headOfficeAdress: '',
  createdAt: null,
  updatedAt: null,
});

// Seuls name / email / status sont réellement obligatoires côté back.
// contact, bankDomiciliation, rib, cryptoAccount peuvent être null (cf. réponse API).
const schema = yup.object({
  name: yup.string().required(t('settings.organizationNameRequired')),
  email: yup.string().required(t('settings.emailRequired')).email(t('settings.emailInvalid')),
  contact: yup.string().nullable(),
  status: yup.string().required(t('settings.statusRequired')),
  description: yup.string().nullable(),
  bankDomiciliation: yup.string().nullable(),
  rib: yup.string().nullable(),
  cryptoAccount: yup.string().nullable(),
});

// Le bouton "Enregistrer" n'est actif que si les champs obligatoires sont valides
const isFormValid = computed(() => {
  return (
    formValues.name.trim().length > 0 &&
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formValues.email) &&
    formValues.status.trim().length > 0
  );
});

function validate(field: keyof typeof errorsBis) {
  // ⭐ Si l'utilisateur n'a pas les droits, on ne valide pas les champs
  if (!canEditOrganization.value) return;

  schema
    .validateAt(field, formValues)
    .then(() => {
      errorsBis[field] = "";
    })
    .catch((err) => {
      errorsBis[field] = err.message;
    });
  errors.value = '';
}

function formatDate(value: string | null): string {
  if (!value) return '';
  const d = new Date(value);
  if (isNaN(d.getTime())) return value;
  return d.toLocaleString();
}

// 1. Récupérer l'utilisateur connecté pour obtenir le code de son organisation
// 2. Récupérer les informations de l'organisation pour préremplir le formulaire
const loadOrganization = () => {
  axios
    .get(backApi + '/secure/users/' + codeUser + '/show', {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then((userResponse) => {
      const organizationCode = userResponse.data?.organization?.code;

      if (!organizationCode) {
        errors.value = t('settings.organizationNotFound');
        pageLoad.value = true;
        return;
      }

      axios
        .get(backApi + '/secure/organizations/' + organizationCode + '/show', {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then((orgResponse) => {
          const data = orgResponse.data;
          formValues.code = data.code ?? '';
          formValues.name = data.name ?? '';
          formValues.description = data.description ?? '';
          formValues.email = data.email ?? '';
          formValues.contact = data.contact ?? '';
          formValues.status = data.status ?? 'ACTIVE';
          formValues.bankDomiciliation = data.bankDomiciliation ?? '';
          formValues.rib = data.rib ?? '';
          formValues.cryptoAccount = data.cryptoAccount ?? '';
          formValues.validatePayoutBeforProcess = data.validatePayoutBeforProcess ?? false;
          formValues.maxPayoutAmount = data.maxPayoutAmount ?? null;
          formValues.payoutValidationDelay = data.payoutValidationDelay ?? null;
          formValues.isTestOrganization = data.isTestOrganization ?? false;
          formValues.type = data.type ?? '';
          formValues.representativeName = data.representativeName ?? '';
          formValues.representativeIdDocs = data.representativeIdDocs ?? '';
          formValues.headOfficeAdress = data.headOfficeAdress ?? '';
          formValues.createdAt = data.createdAt ?? null;
          formValues.updatedAt = data.updatedAt ?? null;
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status === 401) {
              router.push('/');
            } else {
              errorId.value = error.response.data.errorId;
              errors.value = error.response.data.message;
            }
          }
        })
        .finally(() => {
          pageLoad.value = true;
        });
    })
    .catch((error) => {
      pageLoad.value = true;
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/');
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
      }
    });
};

const updateOrganization = async () => {
  // ⭐ Garde-fou : bloque toute soumission si l'utilisateur n'a pas les droits
  if (!canEditOrganization.value) {
    errors.value = t('settings.noEditPermission');
    return;
  }

  try {
    errors.value = '';
    success.value = '';
    btnLoad.value = false;
    await schema.validate(formValues);

    axios
      .put(backApi + '/secure/organizations/' + formValues.code + '/edit', {
        code: formValues.code,
        name: formValues.name,
        description: formValues.description,
        email: formValues.email,
        contact: formValues.contact,
        status: formValues.status,
        bankDomiciliation: formValues.bankDomiciliation,
        rib: formValues.rib,
        cryptoAccount: formValues.cryptoAccount,
        validatePayoutBeforProcess: formValues.validatePayoutBeforProcess,
        maxPayoutAmount: formValues.maxPayoutAmount,
        payoutValidationDelay: formValues.payoutValidationDelay,
        representativeName: formValues.representativeName,
        representativeIdDocs: formValues.representativeIdDocs,
        headOfficeAdress: formValues.headOfficeAdress,
      }, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      })
      .then((response) => {
        btnLoad.value = true;
        if (response.status === 200) {
          success.value = response.data.msg ?? t('settings.organizationUpdated');
        }
      })
      .catch((error) => {
        btnLoad.value = true;
        if (error.response) {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
          if (error.response.status === 401) {
            router.push('/');
          }
        }
      });
  } catch (error) {
    btnLoad.value = true;
    console.error(error);
    errors.value = "une erreur inattendue est apparue";
  }
};

onMounted(() => {
  checkSessionValidate(1);
  loadOrganization();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (pageLoad.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("ul", _hoisted_5, [
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    to: "/account-settings",
                    class: "fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition settings-tab-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('settings.personalInfo')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    to: "/settings-change-password",
                    class: "fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition settings-tab-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('settings.changePassword')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    to: "/settings-organization",
                    class: "fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition settings-tab-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('settings.editOrganization')), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          (canEditOrganization.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  (errors.value !== '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("h6", _hoisted_9, _toDisplayString(errorId.value), 1),
                        _createElementVNode("h6", _hoisted_10, _toDisplayString(errors.value), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (success.value !== '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("h6", _hoisted_12, _toDisplayString(success.value), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("form", {
                    onSubmit: _withModifiers(updateOrganization, ["prevent"])
                  }, [
                    _createElementVNode("fieldset", null, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('settings.organizationCode')), 1),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formValues.code) = $event)),
                              type: "text",
                              readonly: "",
                              class: "form-control shadow-none rounded-0 text-black bg-light"
                            }, null, 512), [
                              [_vModelText, formValues.code]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('settings.organizationType')), 1),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formValues.type) = $event)),
                              type: "text",
                              readonly: "",
                              class: "form-control shadow-none rounded-0 text-black bg-light"
                            }, null, 512), [
                              [_vModelText, formValues.type]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('settings.organizationName')), 1),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formValues.name) = $event)),
                              type: "text",
                              class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-invalid': errorsBis['name'] }]),
                              onBlur: _cache[3] || (_cache[3] = ($event: any) => (validate('name'))),
                              onKeyup: _cache[4] || (_cache[4] = ($event: any) => (validate('name')))
                            }, null, 34), [
                              [_vModelText, formValues.name]
                            ]),
                            _createElementVNode("span", _hoisted_23, _toDisplayString(errorsBis['name']), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t('settings.email')), 1),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formValues.email) = $event)),
                              type: "email",
                              class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-invalid': errorsBis['email'] }]),
                              onBlur: _cache[6] || (_cache[6] = ($event: any) => (validate('email'))),
                              onKeyup: _cache[7] || (_cache[7] = ($event: any) => (validate('email')))
                            }, null, 34), [
                              [_vModelText, formValues.email]
                            ]),
                            _createElementVNode("span", _hoisted_27, _toDisplayString(errorsBis['email']), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t('settings.contact')), 1),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formValues.contact) = $event)),
                              type: "text",
                              class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-invalid': errorsBis['contact'] }]),
                              onBlur: _cache[9] || (_cache[9] = ($event: any) => (validate('contact'))),
                              onKeyup: _cache[10] || (_cache[10] = ($event: any) => (validate('contact')))
                            }, null, 34), [
                              [_vModelText, formValues.contact]
                            ]),
                            _createElementVNode("span", _hoisted_31, _toDisplayString(errorsBis['contact']), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.$t('settings.status')), 1),
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formValues.status) = $event)),
                              class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-invalid': errorsBis['status'] }]),
                              onChange: _cache[12] || (_cache[12] = ($event: any) => (validate('status')))
                            }, [
                              _createElementVNode("option", _hoisted_35, _toDisplayString(_ctx.$t('settings.statusActive')), 1),
                              _createElementVNode("option", _hoisted_36, _toDisplayString(_ctx.$t('settings.statusInactive')), 1)
                            ], 34), [
                              [_vModelSelect, formValues.status]
                            ]),
                            _createElementVNode("span", _hoisted_37, _toDisplayString(errorsBis['status']), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.$t('settings.description')), 1),
                            _withDirectives(_createElementVNode("textarea", {
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formValues.description) = $event)),
                              rows: "3",
                              class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-invalid': errorsBis['description'] }]),
                              onBlur: _cache[14] || (_cache[14] = ($event: any) => (validate('description'))),
                              onKeyup: _cache[15] || (_cache[15] = ($event: any) => (validate('description')))
                            }, null, 34), [
                              [_vModelText, formValues.description]
                            ]),
                            _createElementVNode("span", _hoisted_41, _toDisplayString(errorsBis['description']), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.$t('settings.bankDomiciliation')), 1),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formValues.bankDomiciliation) = $event)),
                              type: "text",
                              class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-invalid': errorsBis['bankDomiciliation'] }]),
                              onBlur: _cache[17] || (_cache[17] = ($event: any) => (validate('bankDomiciliation'))),
                              onKeyup: _cache[18] || (_cache[18] = ($event: any) => (validate('bankDomiciliation')))
                            }, null, 34), [
                              [_vModelText, formValues.bankDomiciliation]
                            ]),
                            _createElementVNode("span", _hoisted_45, _toDisplayString(errorsBis['bankDomiciliation']), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.$t('settings.rib')), 1),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((formValues.rib) = $event)),
                              type: "text",
                              class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-invalid': errorsBis['rib'] }]),
                              onBlur: _cache[20] || (_cache[20] = ($event: any) => (validate('rib'))),
                              onKeyup: _cache[21] || (_cache[21] = ($event: any) => (validate('rib')))
                            }, null, 34), [
                              [_vModelText, formValues.rib]
                            ]),
                            _createElementVNode("span", _hoisted_49, _toDisplayString(errorsBis['rib']), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.$t('settings.cryptoAccount')), 1),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((formValues.cryptoAccount) = $event)),
                              type: "text",
                              class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-invalid': errorsBis['cryptoAccount'] }]),
                              onBlur: _cache[23] || (_cache[23] = ($event: any) => (validate('cryptoAccount'))),
                              onKeyup: _cache[24] || (_cache[24] = ($event: any) => (validate('cryptoAccount')))
                            }, null, 34), [
                              [_vModelText, formValues.cryptoAccount]
                            ]),
                            _createElementVNode("span", _hoisted_53, _toDisplayString(errorsBis['cryptoAccount']), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("div", _hoisted_55, [
                            _createElementVNode("label", _hoisted_56, _toDisplayString(_ctx.$t('settings.representativeName')), 1),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((formValues.representativeName) = $event)),
                              type: "text",
                              class: "form-control shadow-none rounded-0 text-black"
                            }, null, 512), [
                              [_vModelText, formValues.representativeName]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_57, [
                          _createElementVNode("div", _hoisted_58, [
                            _createElementVNode("label", _hoisted_59, _toDisplayString(_ctx.$t('settings.representativeIdDocs')), 1),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((formValues.representativeIdDocs) = $event)),
                              type: "text",
                              class: "form-control shadow-none rounded-0 text-black"
                            }, null, 512), [
                              [_vModelText, formValues.representativeIdDocs]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_60, [
                          _createElementVNode("div", _hoisted_61, [
                            _createElementVNode("label", _hoisted_62, _toDisplayString(_ctx.$t('settings.headOfficeAddress')), 1),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((formValues.headOfficeAdress) = $event)),
                              type: "text",
                              class: "form-control shadow-none rounded-0 text-black"
                            }, null, 512), [
                              [_vModelText, formValues.headOfficeAdress]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_63, [
                          _createElementVNode("div", _hoisted_64, [
                            _createElementVNode("label", _hoisted_65, _toDisplayString(_ctx.$t('settings.maxPayoutAmount')), 1),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((formValues.maxPayoutAmount) = $event)),
                              type: "number",
                              class: "form-control shadow-none rounded-0 text-black"
                            }, null, 512), [
                              [
                                _vModelText,
                                formValues.maxPayoutAmount,
                                void 0,
                                { number: true }
                              ]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_66, [
                          _createElementVNode("div", _hoisted_67, [
                            _createElementVNode("label", _hoisted_68, _toDisplayString(_ctx.$t('settings.payoutValidationDelay')), 1),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((formValues.payoutValidationDelay) = $event)),
                              type: "number",
                              class: "form-control shadow-none rounded-0 text-black"
                            }, null, 512), [
                              [
                                _vModelText,
                                formValues.payoutValidationDelay,
                                void 0,
                                { number: true }
                              ]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_69, [
                          _createElementVNode("div", _hoisted_70, [
                            _withDirectives(_createElementVNode("input", {
                              id: "validatePayoutBeforProcess",
                              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((formValues.validatePayoutBeforProcess) = $event)),
                              type: "checkbox",
                              class: "form-check-input me-10"
                            }, null, 512), [
                              [_vModelCheckbox, formValues.validatePayoutBeforProcess]
                            ]),
                            _createElementVNode("label", _hoisted_71, _toDisplayString(_ctx.$t('settings.validatePayoutBeforProcess')), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_72, [
                          _createElementVNode("div", _hoisted_73, [
                            _withDirectives(_createElementVNode("input", {
                              id: "isTestOrganization",
                              "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((formValues.isTestOrganization) = $event)),
                              type: "checkbox",
                              class: "form-check-input me-10",
                              disabled: ""
                            }, null, 512), [
                              [_vModelCheckbox, formValues.isTestOrganization]
                            ]),
                            _createElementVNode("label", _hoisted_74, _toDisplayString(_ctx.$t('settings.isTestOrganization')), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_75, [
                          _createElementVNode("div", _hoisted_76, [
                            _createElementVNode("label", _hoisted_77, _toDisplayString(_ctx.$t('settings.createdAt')), 1),
                            _createElementVNode("input", {
                              value: formatDate(formValues.createdAt),
                              type: "text",
                              readonly: "",
                              class: "form-control shadow-none rounded-0 text-black bg-light"
                            }, null, 8, _hoisted_78)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_79, [
                          _createElementVNode("div", _hoisted_80, [
                            _createElementVNode("label", _hoisted_81, _toDisplayString(_ctx.$t('settings.updatedAt')), 1),
                            _createElementVNode("input", {
                              value: formatDate(formValues.updatedAt),
                              type: "text",
                              readonly: "",
                              class: "form-control shadow-none rounded-0 text-black bg-light"
                            }, null, 8, _hoisted_82)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_83, [
                        _createElementVNode("button", {
                          class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16",
                          type: "submit",
                          style: {"background-color":"#EB9355"},
                          disabled: !btnLoad.value || !isFormValid.value
                        }, [
                          (!btnLoad.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_85))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('settings.saveChanges')), 1)
                        ], 8, _hoisted_84)
                      ])
                    ])
                  ], 32)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_86, [...(_cache[32] || (_cache[32] = [
        _createElementVNode("div", {
          class: "spinner-border text-primary",
          role: "status"
        }, [
          _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
        ], -1)
      ]))]))
}
}

})